var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zyk_w" },
    [
      _c("div", { staticClass: "banner" }, [
        _c("img", {
          attrs: {
            src: _vm.$store.getters.wTitle.competitionBanner
              ? _vm.$store.getters.wTitle.competitionBanner
              : _vm.imgBanner,
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "bannerTit" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "Title" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$store.getters.wTitle) + "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "s_w" },
          [_c("Search", { attrs: { type: 1 } })],
          1
        ),
      ]),
      _vm._v(" "),
      _c("Nav", { attrs: { num: 5 } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tab" },
        _vm._l(_vm.tabList, function (i, j) {
          return _c(
            "div",
            {
              staticClass: "item",
              class: { active: _vm.curIndex == j },
              on: {
                click: function ($event) {
                  return _vm.tabs(i, j)
                },
              },
            },
            [_vm._v(_vm._s(i))]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.curIndex == 1
        ? _c("Menus", {
            attrs: { menusList: _vm.menusList },
            on: {
              curLable: function ($event) {
                return _vm.chooseList(arguments)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.curIndex == 0
        ? _c("div", { staticClass: "courseL" }, [
            _c(
              "div",
              { staticClass: "list", class: { listNews: _vm.curIndex == 0 } },
              [
                _vm._l(_vm.list, function (i) {
                  return _vm.list.length > 0
                    ? _c("div", { staticClass: "itemNews" }, [
                        _c("div", { staticClass: "time" }, [
                          _c("div", { staticClass: "day" }, [
                            _vm._v(_vm._s(_vm._f("day")(i.createTime))),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "year" }, [
                            _vm._v(_vm._s(_vm._f("year")(i.createTime))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "line" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "rightTit" }, [
                          _c(
                            "div",
                            {
                              staticClass: "tit",
                              on: {
                                click: function ($event) {
                                  return _vm.lookDetail(i)
                                },
                              },
                            },
                            [_vm._v(_vm._s(i.newsTitle))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "tips" }, [
                            _vm._v(_vm._s(i.contestTypeName)),
                            _c("span", [_vm._v(_vm._s(i.courseLevelName))]),
                            _vm._v(_vm._s(i.yearName)),
                          ]),
                        ]),
                      ])
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm.list.length == 0
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "margin-top": "50px",
                          "text-align": "center",
                        },
                      },
                      [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
                    )
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "paginationX" },
              [
                _vm.total0 > 1
                  ? _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page": _vm.query0.pageNum,
                        "page-size": _vm.query0.pageSize,
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.total0,
                      },
                      on: {
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.handleSizeChange,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.curIndex == 1
        ? _c(
            "div",
            { staticClass: "courseL" },
            [
              _vm._l(_vm.workList, function (item) {
                return _vm.workList.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "listItem",
                        on: {
                          click: function ($event) {
                            return _vm.toComDetail(item)
                          },
                        },
                      },
                      [_c("WinCourse", { attrs: { type: 6 } })],
                      1
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.workList.length == 0
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "50px",
                        "text-align": "center",
                      },
                    },
                    [_c("img", { attrs: { src: _vm.$store.getters.noData } })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "paginationX" },
                [
                  _vm.total1 > 0
                    ? _c("el-pagination", {
                        attrs: {
                          background: "",
                          "current-page": _vm.query1.pageNum,
                          "page-size": _vm.query1.pageSize,
                          layout: "total, sizes, prev, pager, next, jumper",
                          total: _vm.total1,
                        },
                        on: {
                          "current-change": _vm.handleCurrentChange,
                          "size-change": _vm.handleSizeChange,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bannerLogin" }, [
      _c("img", {
        attrs: {
          src: require("../../../assets/img/image/index-logo2.png"),
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }